import React from 'react';
import { Link } from 'react-router-dom';
import { ScrollText } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageWrapper from '../components/PageWrapper';
import SEOMeta from '../components/SEOMeta';

const SECTIONS = [
  {
    title: '1. Aceptación de los Términos',
    body: `Al crear una cuenta y acceder al servidor Frostbound, aceptas íntegramente estos Términos de Servicio. Si no estás de acuerdo con alguna de las condiciones aquí descritas, no debes utilizar el servicio.

Frostbound es un servidor privado de World of Warcraft 3.3.5a (Wrath of the Lich King) sin ánimo de lucro, operado de forma independiente y sin afiliación con Blizzard Entertainment. World of Warcraft® es marca registrada de Blizzard Entertainment, Inc.`,
  },
  {
    title: '2. Elegibilidad',
    body: `El acceso al servidor está permitido a cualquier persona mayor de 13 años. Si eres menor de 18 años, necesitas el consentimiento de un tutor legal para utilizar el servicio.

No está permitido crear múltiples cuentas con el objetivo de obtener ventajas injustas sobre otros jugadores (multicuenta con fines de abuso).`,
  },
  {
    title: '3. Normas de Conducta',
    body: `Al utilizar Frostbound te comprometes a:

• No utilizar software de terceros, bots o hacks para obtener ventajas (con excepción de los Playerbots oficiales del servidor).
• No acosar, insultar ni discriminar a otros jugadores por ningún motivo.
• No difundir spam ni publicidad en los chats del juego o la web.
• No intentar acceder a cuentas ajenas ni explotar vulnerabilidades del sistema.
• No comerciar cuentas, personajes u objetos del juego por dinero real fuera de la tienda oficial.
• Respetar las decisiones del equipo de administración.

El incumplimiento de estas normas puede resultar en suspensión temporal o baneo permanente sin previo aviso.`,
  },
  {
    title: '4. Cuentas y Seguridad',
    body: `Eres responsable de mantener la confidencialidad de tus credenciales de acceso. Frostbound no se hace responsable de pérdidas derivadas del acceso no autorizado a tu cuenta.

Si detectas un acceso no autorizado, debes notificarlo de inmediato al equipo de soporte a través del Discord oficial o escribiendo a staff@frostbound.wow.

Las cuentas son de uso personal e intransferible.`,
  },
  {
    title: '5. Tienda y Cristales de Escarcha',
    body: `La tienda de Frostbound opera con Cristales de Escarcha, la moneda virtual del servidor. Los cristales pueden adquirirse mediante donaciones voluntarias o mediante mecánicas del juego.

• Las donaciones son voluntarias y no reembolsables salvo error técnico demostrable.
• Los cristales no tienen valor monetario real y no pueden intercambiarse por dinero.
• Frostbound se reserva el derecho de modificar los precios de la tienda y el catálogo de productos en cualquier momento.
• La compra de productos de la tienda no garantiza ventajas competitivas irreversibles; el equipo de administración puede realizar ajustes de balance en cualquier momento.`,
  },
  {
    title: '6. Modificaciones del Servicio',
    body: `Frostbound se reserva el derecho de:

• Modificar, suspender o interrumpir el servicio en cualquier momento, con o sin previo aviso.
• Actualizar estos Términos de Servicio. Los cambios serán publicados en la web y entrarán en vigor a los 7 días de su publicación.
• Realizar wipes (reinicios de personajes) en casos excepcionales, previa notificación a la comunidad.

El uso continuado del servicio tras la publicación de cambios implica la aceptación de los nuevos términos.`,
  },
  {
    title: '7. Limitación de Responsabilidad',
    body: `Frostbound se ofrece "tal cual" y sin garantías de disponibilidad continua. No nos hacemos responsables de:

• Pérdida de progreso, personajes u objetos debidos a fallos técnicos, corrupción de base de datos o mantenimiento.
• Daños indirectos derivados del uso o imposibilidad de uso del servicio.
• Contenido generado por otros usuarios en los chats o foros del servidor.

Hacemos nuestro mejor esfuerzo para mantener el servidor estable, pero al tratarse de un proyecto sin ánimo de lucro, los recursos son limitados.`,
  },
  {
    title: '8. Propiedad Intelectual',
    body: `World of Warcraft y todos sus activos (imágenes, modelos, sonidos, lore) son propiedad de Blizzard Entertainment. Frostbound no reclama propiedad sobre ninguno de estos activos.

El código fuente del emulador se basa en AzerothCore, distribuido bajo licencia GNU AGPL v3.

El código y diseño propios del portal web de Frostbound son propiedad del equipo de Frostbound.`,
  },
  {
    title: '9. Contacto',
    body: `Para cualquier consulta sobre estos Términos de Servicio, puedes contactarnos en:

• Email: staff@frostbound.wow
• Discord: servidor oficial de Frostbound

Última actualización: marzo de 2026`,
  },
];

export default function TerminosPage() {
  return (
    <PageWrapper scrollable>
      <SEOMeta
        title="Términos de servicio"
        description="Condiciones de uso del servidor privado WoW Frostbound. Normas de la comunidad, cuentas y contenido del juego."
        canonical="/terminos"
      />
      <Navbar />
      <main className="legal-main">
        <div className="legal-header anim-fade-up">
          <h1 className="shop-title">
            <ScrollText size={28} className="shop-title-icon" />
            TÉRMINOS DE SERVICIO
          </h1>
          <p className="shop-subtitle">
            Lee atentamente antes de unirte a{' '}
            <span className="cyan-highlight">Frostbound.</span>
          </p>
        </div>

        <div className="legal-body anim-fade-up" style={{ animationDelay: '0.2s' }}>
          {SECTIONS.map((s) => (
            <div key={s.title} className="legal-section">
              <h2 className="legal-section-title">{s.title}</h2>
              <p className="legal-section-body">{s.body}</p>
            </div>
          ))}

          <div className="legal-back">
            <Link to="/registro" className="home-info-link">
              ← Volver al registro
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </PageWrapper>
  );
}
